import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Network } from "../../API";
import { QueryStatus } from "../../app/types";
import { RootState } from "../../app/store";

interface NetworksSlice {
  networks?: Network[] | null;
  networksStatus: QueryStatus;
  networksError?: string;
}

const initialState: NetworksSlice = {
  networks: [],
  networksStatus: "idle"
};

export const networksSlice = createSlice({
  name: "networks",
  initialState,
  reducers: {
    setNetworks: (
      state,
      action: PayloadAction<Network[] | null | undefined>
    ) => {
      state.networks = action.payload;
    },
    setNetworksStatus: (state, action: PayloadAction<QueryStatus>) => {
      state.networksStatus = action.payload;
    },
    setNetworksError: (state, action: PayloadAction<string | undefined>) => {
      state.networksError = action.payload;
    }
  }
});

export const { setNetworks, setNetworksStatus, setNetworksError } =
  networksSlice.actions;

export const selectNetworks = (state: RootState) =>
  state.networks.networks ?? [];
export const selectNetworksStatus = (state: RootState) =>
  state.networks.networksStatus;
export const selectNetworksError = (state: RootState) =>
  state.networks.networksError;

export default networksSlice.reducer;
